import { render, staticRenderFns } from "./TextGenerator_mobile.vue?vue&type=template&id=32e3a895&scoped=true&"
import script from "./TextGenerator_mobile.vue?vue&type=script&lang=js&"
export * from "./TextGenerator_mobile.vue?vue&type=script&lang=js&"
import style0 from "./TextGenerator_mobile.vue?vue&type=style&index=0&id=32e3a895&lang=scss&scoped=true&"
import style1 from "./TextGenerator_mobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e3a895",
  null
  
)

export default component.exports